import React from 'react';
import ActivityLoader from '../../components/Common/ActivityLoader';

const PlanBreakdownCard = ({
  plans,
  bestPlanId,
  money,
  formatCount,
  loading,
  noData,
  styles,
}) => {
  return (
    <div className="card custom-card mb-4" style={styles.softCard}>
      <div className="card-body">
        <div className="d-flex align-items-center mb-3">
          <div>
            <h6 className="card-title mb-1">Plan Breakdown</h6>
            <p className="text-muted tx-12 mb-0">
              Contribution by plan (ranked by revenue)
            </p>
          </div>
        </div>

        {loading && <ActivityLoader />}

        <div className="table-responsive overflow-auto" style={{maxHeight: '300px'}}>
          <table className="table table-sm table-hover mb-0">
            <thead className="thead-light">
              <tr>
                <th style={{ width: 40 }}>#</th>
                <th>Plan</th>
                <th>Vouchers</th>
                <th>Amount</th>
                <th style={{ width: 160 }}>Share</th>
                <th>Avg Price</th>
                <th>First Use</th>
                <th>Last Use</th>
              </tr>
            </thead>
            <tbody>
              {plans.map((plan) => (
                <tr key={plan.plan_id}>
                  <td className="text-muted">{plan.__rank}</td>
                  <td className="font-weight-semibold">
                    {plan.plan_name || `Plan #${plan.plan_id}`}
                    {bestPlanId === plan.plan_id && (
                      <span className="ml-2 badge badge-success">Best</span>
                    )}
                  </td>
                  <td>{formatCount(plan.vouchers_sold)}</td>
                  <td>{money(plan.amount_sold)}</td>
                  <td>
                    <div className="d-flex align-items-center">
                      <div
                        style={{
                          height: 6,
                          width: 90,
                          borderRadius: 999,
                          background: 'rgba(255,255,255,0.08)',
                          overflow: 'hidden',
                          marginRight: 8,
                        }}
                      >
                        <div
                          style={{
                            width: `${plan.__percent}%`,
                            height: '100%',
                            background:
                              'linear-gradient(90deg, rgba(139,92,246,0.9), rgba(14,165,233,0.9))',
                          }}
                        />
                      </div>
                      <span className="text-muted small">
                        {plan.__percent.toFixed(1)}%
                      </span>
                    </div>
                  </td>
                  <td>{money(plan.avg_price)}</td>
                  <td>{plan.first_used_at || '—'}</td>
                  <td>{plan.last_used_at || '—'}</td>
                </tr>
              ))}

              {noData && (
                <tr>
                  <td colSpan={8} className="text-center text-muted">
                    No plan data available.
                  </td>
                </tr>
              )}

              {!plans.length && !noData && (
                <tr>
                  <td colSpan={8} className="text-center text-muted">
                    No plans match the filters.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PlanBreakdownCard;
